import(/* webpackMode: "eager" */ "/root/mysticoracle/mysticoracle/src/app/not-found.tsx");
